// frontend/app/components/lessonPlans/teachsense/TeachSenseRecommendations.js
//
// The first thing a teacher reads, and for many of them the only thing: what to
// do next, in sentences. Everything below it on the TeachSense view is the
// evidence for these lines.
//
// The server writes them from templates rather than from a model, so opening
// the panel at 9:03am never waits on an API call.

import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { Section } from "./TeachSenseSection";

const TeachSenseRecommendations = ({
  recommendations = null,
  colors,
  isDarkMode = false,
  isNarrow = false,
  t,
}) => {
  const translate = t || ((value) => value);
  // Anything that is not a usable sentence is dropped rather than drawn as a
  // blank bullet — a payload with a null in it should read as one fewer line.
  const lines = (Array.isArray(recommendations) ? recommendations : [])
    .map((line) => String(line ?? "").trim())
    .filter(Boolean);

  return (
    <Section
      testID="teachsense-recommendations"
      colors={colors}
      isNarrow={isNarrow}
      icon="lightbulb-on-outline"
      accent={colors.accentPrimary}
      title={translate("What to do next")}
      isEmpty={lines.length === 0}
      empty={translate("No recommendations yet — they appear once the class has answered a few checks.")}
    >
      {lines.map((line, index) => (
        <View key={`${index}-${line}`} style={index > 0 ? styles.stacked : null}>
          <View style={styles.row}>
            <View style={[styles.marker, { backgroundColor: colors.accentPrimary }]} />
            <Text style={[styles.text, { color: colors.textPrimary }]}>{line}</Text>
          </View>
        </View>
      ))}
    </Section>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: "row", alignItems: "flex-start" },
  // A dot rather than a numeral: these are not ranked, and numbering them
  // invites a teacher to work through them in order.
  marker: { width: 5, height: 5, borderRadius: 999, marginTop: 8, marginRight: 10 },
  // Capped at a readable measure instead of running the full card width.
  text: { flex: 1, fontSize: 14, fontWeight: "600", lineHeight: 21, maxWidth: 720 },
  stacked: { marginTop: 8 },
});

export default TeachSenseRecommendations;
